<div class="flex flex-row">
  <app-toolbar [items]="breadcrumbItems" class="w-100-percent"></app-toolbar>
</div>

<div class="flex flex-row justify-between items-center pl-24 pr-24 pb-8 pt-32">
  <div class="mat-headline-5 m-0">{{'LEFT_SIDE_NAV.LINE_OF_BUSINESS' | transloco }}</div>
  <div>
    <button *ngIf="permissionsMap[Permission.ADD_LOB]" type="button" class="flex justify-center items-center lob-gradient mat-subtitle-2 fw-700 m-0 pl-16 pr-16" 
      mat-button (click)="addNewClick()">
      <mat-icon svgIcon="add" class="icon-md-2 pr-4"></mat-icon>
      {{'LINE_OF_BUSINESS.ADD_NEW_LOB' | transloco }}
    </button>
  </div>
</div>

<div class="p-24">
  <div class="flex flex-col border-radius">
    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" class="mat-elevation">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'LINE_OF_BUSINESS.LOB_NAME' | transloco | uppercase }}</th>
        <td mat-cell *matCellDef="let data" class="cursor-pointer" (click)="openInstanceDetails(data)">{{data.name}}</td>
      </ng-container>
  
      <ng-container matColumnDef="displayName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'LINE_OF_BUSINESS.DISPLAY_NAME' | transloco | uppercase }} </th>
        <td mat-cell *matCellDef="let data"> {{data.displayName}} </td>
      </ng-container>
  
      <ng-container matColumnDef="tagLine">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'LINE_OF_BUSINESS.TAG_LINE' | transloco | uppercase }} </th>
        <td mat-cell *matCellDef="let data"><div class="cell-data tag-line" [title]="data.tagline">{{data.tagline}}</div></td>
      </ng-container>
  
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'LINE_OF_BUSINESS.DESCRIPTION' | transloco | uppercase }} </th>
        <td mat-cell *matCellDef="let data"><div class="cell-data" [title]="data.shortDescription">{{data.shortDescription}}</div></td>
      </ng-container>
  
      <ng-container matColumnDef="image">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'LINE_OF_BUSINESS.IMAGE' | transloco | uppercase }} </th>
        <td mat-cell *matCellDef="let data"> <a [href]="data.imageRef" class="image-link cell-data"
          target="_blank" [title]="data.imageRef">{{data.imageRef}}</a></td>
      </ng-container>
  
      <ng-container matColumnDef="noOfSolutions">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'LINE_OF_BUSINESS.NO_OF_SOLUTIONS' | transloco | uppercase }} </th>
        <td mat-cell *matCellDef="let data"> {{data.numOfSolutions}} </td>
      </ng-container>
  
      <ng-container matColumnDef="menu">
        <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"></th>
        <td mat-cell *matCellDef="let data">
          <button class="flex justify-center items-center context-menu-icon pl-6 pr-6 pt-8"
            [matMenuTriggerFor]="instanceSubmenu">
            <mat-icon svgIcon="more_vert"></mat-icon>
          </button>
          <mat-menu #instanceSubmenu [xPosition]="'before'" class="context-menu-dropdown">
            <div class="flex flex-col" (click)="editLob(data)">
              <button class="menu-button" [ngClass]="{'disable' :!permissionsMap[Permission.EDIT_LOB] }">
                <div class="flex flex-row justify-start items-center">
                  <mat-icon svgIcon="edit" class="icon-md"></mat-icon>
                  <div class="mat-body fw-400">{{'SOLUTIONS.EDIT' | transloco }}</div>
                </div>
              </button>
              <button class="menu-button" [ngClass]="{'disable' :!permissionsMap[Permission.DELETE_LOB] }" (click)="deleteLob(data)">
                <div class="flex flex-row justify-start items-center">
                  <mat-icon svgIcon="delete" class="icon-md"></mat-icon>
                  <div class="mat-body fw-400">{{'SOLUTIONS.DELETE' | transloco }}</div>
                </div>
              </button>
            </div>
          </mat-menu>
        </td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-card *ngIf="showSpinner" class="flex spinner-container spinner p-30">
      <mat-spinner diameter="24"
        color="primary"
        mode="indeterminate">
      </mat-spinner>
    </mat-card>
    <div *ngIf="lobData?.length === 0 && !showSpinner && !isFailed" class="flex items-center justify-center pt-48 pb-48">
      {{'LINE_OF_BUSINESS.NO_LOB_MESSAGE' | transloco }}
    </div>
    <div *ngIf="isFailed" class="flex items-center justify-center pt-48 pb-48">
      {{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}
    </div>
    <app-paginator *ngIf="showPagination && !showSpinner && !isFailed" class="p-24" [length]="lobData?.length" [pageSizeOptions]="[10, 15, 20]"
      [pageSize]="paginationSize" [pageIndex]="pageIndex" [rangeSize]="3" (page)="pageChanged($event)"></app-paginator>
  </div>
</div>
